import { Nullable } from 'types';

export const toColonTimeFromMs = (timeInMs: Nullable<number>): string => {
  const min: number = timeInMs ? Math.floor(timeInMs / 60000) : 0;
  const sec = timeInMs ? Number(((timeInMs % 60000) / 1000).toFixed(0)) : 0;
  return `${min}:${sec < 10 ? '0' : ''}${sec}`;
};

export const convertMinutesIntoSeconds = (
  minutes: number,
  seconds: number
): number => {
  const minutesInSeconds = minutes * 60;
  return minutesInSeconds + seconds;
};
